import { initialState } from "./slice";
import { createSelector } from "reselect";

export const selectProject = (state) =>
  state.project || initialState;

export const selectEntities = createSelector(
  selectProject,
  (selectProject) => selectProject.entities
);

export const selectIds = createSelector(
  selectProject,
  (selectProject) => selectProject.ids
);

export const selectDraftingObject = createSelector(
  selectProject,
  (selectProject) => selectProject.draftingObject
);

export const selectTogglePreview = createSelector(
  selectProject,
  (selectProject) => selectProject.togglePreview
);

export const selectTestResultUrl = createSelector(
  selectProject,
  (selectProject) => selectProject.testResultUrl
);

export const selectJsonTemplateData = createSelector(
  selectProject,
  (selectProject) => selectProject.jsonTemplateData
);

export const selectProjectObject = createSelector(
  selectEntities,
  selectIds,
  (entities, ids) => ids.map((id) => entities[id])
);

